import { Sidebar } from "primereact/sidebar";
import useApi from "../../hooks/ApiHook";
import { useEffect, useState } from "react";
import Loading from "../../components/Loading";

export default function({ movementId, onHide }) {

    const api = useApi();
    const [ movement, setMovement ] = useState();
    const [ visible, setVisible ] = useState(false);

    useEffect(() => {
        if (!movementId) {
            setVisible(false);
            return;
        }
        setVisible(true);
        setMovement(undefined);
        api.get(`movements/${movementId}`).then(({ data }) => {
            setMovement(data);
        });
    }, [movementId]);

    return (
        <Sidebar visible={visible} position="right" className="md:w-30rem" onHide={onHide}>
            <div className="h-full flex flex-column">
                <h2>Movimento</h2>
                {!movement && <Loading/>}
                {movement && (
                    <>
                        <div>
                            <div className="mb-1"><strong>Destino: </strong>{movement.destiny.commercialName}</div>
                            <div className="mb-1"><strong>Tipo: </strong>{movement.type}</div>
                            <div className="mb-1"><strong>Data/hora: </strong>{new Date(movement.at).toLocaleString()}</div>
                        </div>
                        <div className="mt-4">
                            <div className="mb-1"><strong>Nfe</strong></div>
                            {movement.nfeList?.map(i => <Nfe nfe={i}/>)}
                        </div>
                        <div className="w-full flex-grow-1 mt-4 max-w-full flex-shrink-1 overflow-y-hidden overflow-y-scroll">
                            <div className="mb-1"><strong>Itens</strong></div>
                            {movement.items.map(i => <Item item={i}/>)}
                        </div>
                    </>
                )}
            </div>
        </Sidebar>
    );
}

function Item({ item }) {
    return (
        <div className="py-4 border-solid border-none border-bottom-1 border-300">
            <div className="font-bold mb-1">
                {item.product.description}
            </div>
            <div className="mb-1">
                Cod: {item.product.code}
            </div>
            <div>Qtd: {item.quantity} {item.unit}</div>
        </div>
    )
}

function Nfe({ nfe }) {
    return (
        <div className="py-4 border-solid border-none border-bottom-1 border-300">
            <div className="font-bold mb-1">
                {nfe.id}
            </div>
            <div className="mb-1">
                Status: {nfe.status}
            </div>
            {nfe.message && (
                <div className="mb-1">
                    Status: {nfe.message}
                </div>
            )}
        </div>
    )
}